import React, { Component } from "react";
import { TweenLite, Power0 } from "gsap";

import "./PortfolioTools.css";
import iconShuffleSrc from "../img/icon-refresh.png";
import iconFilterSrc from "../img/icon-filter.png";
import iconShowSrc from "../img/icon-show.png";

export default class PortfolioTools extends Component {
	state = {
		showFilterField: false, // true for debug
	};

	shuffle = () => {
		TweenLite.to(this.shuffleIcon, 0.5, {
			rotation: "+=360",
			transformOrigin: "50% 50%",
			ease: Power0.easeInOut,
		});

		this.props.shuffle();
	};

	toggleFilter = () => {
		// This will reset filter on close
		if (this.state.showFilterField === true) {
			this.props.filter("");
			this.searchField.value = "";
			this.searchField.disabled = true;
			this.filterElement.classList.add("Hidden");
		} else {
			this.searchField.disabled = false;
			this.filterElement.classList.remove("Hidden");
		}

		this.setState({ showFilterField: !this.state.showFilterField });
	};

	componentDidMount = () => {
		document.addEventListener("keyup", this.handleKey);
	};

	componentWillUnmount = () => {
		document.removeEventListener("keyup", this.handleKey);
	};

	handleKey = event => {
		// console.log("handleKey", event);

		switch (event.key) {
			case "s":
			case "S":
				if (this.state.showFilterField === false) {
					this.shuffle();
				}
				break;

			case "f":
			case "F":
				if (this.state.showFilterField === false) {
					this.toggleFilter();
				}
				break;

			case "l":
			case "L":
				if (this.state.showFilterField === false) {
					this.props.toggleLabels();
				}

				break;

			case "Escape":
				if (this.state.showFilterField === true) {
					this.toggleFilter();
				}
				break;

			default:
				break;
		}
	};

	handleChange = event => {
		this.props.filter(event.target.value);
	};

	componentWillReceiveProps = nextProps => {
		// Test to see if the loader has completed, if it has then fade the menu in
		if (nextProps.loaderComplete !== this.props.loaderComplete) {
			this.menuElement.classList.remove("Disabled");
		}
	};

	componentDidUpdate = () => {
		if (this.state.showFilterField === true) {
			this.searchField.focus();
		}
	};

	render() {
		const { showFilterField } = this.state;

		const { toggleLabels, labelsVisible, loaderComplete } = this.props;

		return (
			<div
				className="PortfolioTools"
				ref={element => {
					this.portfolioTools = element;
				}}
			>
				<div
					className={`Menu ${loaderComplete === false && "Disabled"}`}
					ref={element => {
						this.menuElement = element;
					}}
				>
					<button onClick={this.shuffle}>
						<img
							className="Middle"
							src={iconShuffleSrc}
							alt={`Shuffle Images Icon`}
							ref={element => {
								this.shuffleIcon = element;
							}}
						/>
						<span className="Middle">Shuffle</span>
					</button>

					<button onClick={toggleLabels}>
						<img
							className="Middle"
							src={iconShowSrc}
							alt={`Show Labels Icon`}
							ref={element => {
								this.filterIcon = element;
							}}
						/>
						<span className="Middle">
							{labelsVisible === true ? "Hide" : "Show"} Labels
						</span>
					</button>

					<button onClick={this.toggleFilter}>
						<img
							className="Middle"
							src={iconFilterSrc}
							alt={`Filter Images Icon`}
							ref={element => {
								this.filterIcon = element;
							}}
						/>
						<span className="Middle">
							{showFilterField === true ? "Hide" : "Show"} Filter
						</span>
					</button>
				</div>

				<div
					className="Filter Hidden"
					// className="Filter"
					ref={el => {
						this.filterElement = el;
					}}
				>
					<input
						type="search"
						placeholder="Search"
						onChange={this.handleChange}
						ref={element => {
							this.searchField = element;
						}}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/PortfolioTools.js